import React from "react";
import RoleDashboard from "../../shared/RoleDashboard";

export default function Dashboard() {
  return <RoleDashboard role="audit" />;
}
